/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { DataCollectorService } from '../data_collector_services/data_collector_service.service';

@Injectable({
    providedIn: 'root'
})
export class OrganizationService {
    get organizationV2Url(): any{
        return `${this.dataCollectorService.baseurl()}/v2/organization`;
    }
    get organizationUrl(): any{
        return `${this.dataCollectorService.baseurl()}/organization`;
    }
    get OrgApiUrls(): any{
        return {
            columnUrl: `${this.organizationV2Url}/meta`,
            dataUrl: `${this.organizationV2Url}/filter`,
            filterUrl: `${this.organizationV2Url}/meta/filter`,
            bulkActionUrl: `${this.organizationV2Url}/bulk_action`,
            invoiceUrl: `${this.dataCollectorService.baseurl()}/invoice`,
            estimateUrl: `${this.dataCollectorService.baseurl()}/estimate`,
            propertyUrl: `${this.dataCollectorService.baseurl()}/property`,
            serviceContractUrl: `${this.dataCollectorService.baseurl()}/service_contract`,
            assetsUrl: `${this.dataCollectorService.baseurl()}/assets`,
            customersUrl: `${this.dataCollectorService.baseurl()}/customers`,
            projectUrl: `${this.dataCollectorService.baseurl()}/projects`,
            requestUrl: `${this.dataCollectorService.baseurl()}/request`
        };
    }
    organizationDetailsLoaded: Subject<boolean> = new Subject<boolean>();
    currentOrganizationDetails = new BehaviorSubject(null);

    constructor(private dataCollectorService: DataCollectorService) {
        this.organizationDetailsLoaded.next(false);
    }

    activationURl(orgId: string): string {
        return `${this.organizationUrl}/${orgId}/activate`;
    }

    deleteURL(orgId: string): string {
        return `${this.organizationUrl}/${orgId}`;
    }

    getOrganizationDetails(organizationId: string): string {
        return `${this.organizationUrl}/${organizationId}`;
    }

    getOrganizationNotes(organizationId: string): string {
        return `${this.dataCollectorService.baseurl()}/notes`;
    }
    performBulkAction(payload): Observable<any>{
        const url =`${this.organizationUrl}/bulk_action`;
        return this.dataCollectorService.postData(url,payload);
      }
    getPropertyAssociationUrl(organizationId: string): string {
        return `${this.dataCollectorService.baseurl()}/organization/${organizationId}/associations`;
    }
}
